function truncateToDecimalPlaces(number, decimalPlaces) {
  let strNum = String(number);

  if (strNum.indexOf('.') === -1) {
    return strNum + "." + Array.from({length: decimalPlaces}, x => 0).join("")
  }
  return strNum.slice(0, strNum.indexOf('.') + (decimalPlaces + 1))
}

const currency = (float, decimalLimit) => `$${truncateToDecimalPlaces(float, decimalLimit ?? 2)}`

export {
    truncateToDecimalPlaces,
    currency
};